import { render, staticRenderFns } from "./label-with-edit.vue?vue&type=template&id=71a8845a"
import script from "./label-with-edit.vue?vue&type=script&lang=js"
export * from "./label-with-edit.vue?vue&type=script&lang=js"
import style0 from "./label-with-edit.vue?vue&type=style&index=0&id=71a8845a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports